import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SvgLoader } from '@epicuro-next/ataraxia/icons';
import {
  ConfigStripConfigurationKeys,
  ConfigurationsService,
  CONFIG_STRIP_FEATURE,
  NoosIconType,
} from '@epicuro-next/platform/configuration';
import { NeverOutOfStockType } from 'graphql-api/gql-api-interfaces';
import { take } from 'rxjs/operators';

import { NeverOutOfStockIconSize } from './interfaces/never-out-of-stock-icon-size.enum';

@Component({
  selector: 'epc-never-out-of-stock-icon',
  styleUrls: ['./never-out-of-stock-icon.component.scss'],
  template: `<div [class]="iconSize" [innerHTML]="svg | async"></div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NeverOutOfStockIconComponent
  extends SvgLoader
  implements OnChanges
{
  @Input() public type: NeverOutOfStockType;
  @Input() @HostBinding('class') public iconSize: NeverOutOfStockIconSize;

  public errorMessage: string;

  constructor(
    protected sanitizer: DomSanitizer,
    private configurationService: ConfigurationsService,
  ) {
    super(sanitizer);
  }

  public ngOnChanges(changes: SimpleChanges) {
    const currentType = changes.type?.currentValue;
    if (currentType) {
      this.errorMessage = `Unable to load svg for the following icon path: './icons/${currentType.toLowerCase()}.js'`;
      this.svg = super.getSvg(currentType);
    }
  }

  protected async loadSvgContent(type: NeverOutOfStockType) {
    try {
      const iconType = await this.configurationService
        .getConfigValue({
          namespace: CONFIG_STRIP_FEATURE,
          featureName: ConfigStripConfigurationKeys.NoosIconsType,
          defaultValue: NoosIconType.Regular,
        })
        .pipe(take(1))
        .toPromise();

      return (
        await import(
          /* webpackMode: "lazy-once" */
          `./icons/${iconType}/${type.toLowerCase()}.js`
        )
      ).default as string;
    } catch {
      return (
        await import(
          /* webpackMode: "lazy-once" */
          `./icons/regular/${type.toLowerCase()}.js`
        )
      ).default as string;
    }
  }
}
